export const menuDataAutomationType: string = 'Discover';
export const menuButtonDataAutomationId: string = 'DiscoverButton';
